// 1. SEND MESSAGE TYPES
export const SEND_MESSAGE_REQUEST = "SEND_MESSAGE_REQUEST";
export const SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_FAILURE = "SEND_MESSAGE_FAILURE";

// 2. GET ALL SESSIONS (SIDEBAR) TYPES
export const GET_ALL_SESSIONS_REQUEST = "GET_ALL_SESSIONS_REQUEST";
export const GET_ALL_SESSIONS_SUCCESS = "GET_ALL_SESSIONS_SUCCESS";
export const GET_ALL_SESSIONS_FAILURE = "GET_ALL_SESSIONS_FAILURE";

// 3. GET SESSION HISTORY TYPES
export const GET_SESSION_HISTORY_REQUEST = "GET_SESSION_HISTORY_REQUEST";
export const GET_SESSION_HISTORY_SUCCESS = "GET_SESSION_HISTORY_SUCCESS";
export const GET_SESSION_HISTORY_FAILURE = "GET_SESSION_HISTORY_FAILURE";

// 4. CREATE SESSION TYPES
export const CREATE_SESSION_REQUEST = "CREATE_SESSION_REQUEST";
export const CREATE_SESSION_SUCCESS = "CREATE_SESSION_SUCCESS";
export const CREATE_SESSION_FAILURE = "CREATE_SESSION_FAILURE";

// 5. DELETE SESSION TYPES 
export const DELETE_SESSION_REQUEST = "DELETE_SESSION_REQUEST";
export const DELETE_SESSION_SUCCESS = "DELETE_SESSION_SUCCESS";
export const DELETE_SESSION_FAILURE = "DELETE_SESSION_FAILURE";

// 6. CLEAR ALL SESSIONS TYPES
export const CLEAR_ALL_SESSIONS_REQUEST = "CLEAR_ALL_SESSIONS_REQUEST";
export const CLEAR_ALL_SESSIONS_SUCCESS = "CLEAR_ALL_SESSIONS_SUCCESS";
export const CLEAR_ALL_SESSIONS_FAILURE = "CLEAR_ALL_SESSIONS_FAILURE";